export const adultRank = [
  {
    value: 10,
    label: (
      <>
        <img src="/adultBelts/10th.png" alt="10ème" /> 10ème
      </>
    ),
  },
  {
    value: 9,
    label: (
      <>
        <img src="/adultBelts/9th.png" alt="9ème" /> 9ème
      </>
    ),
  },
  {
    value: 8,
    label: (
      <>
        <img src="/adultBelts/8th.png" alt="8ème" /> 8ème
      </>
    ),
  },
  {
    value: 7,
    label: (
      <>
        <img src="/adultBelts/7th.png" alt="7ème" /> 7ème
      </>
    ),
  },
  {
    value: 6,
    label: (
      <>
        <img src="/adultBelts/6th.png" alt="6ème" /> 6ème
      </>
    ),
  },
  {
    value: 5,
    label: (
      <>
        <img src="/adultBelts/5th.png" alt="5ème" /> 5ème
      </>
    ),
  },
  {
    value: 4,
    label: (
      <>
        <img src="/adultBelts/4th.png" alt="4ème" /> 4ème
      </>
    ),
  },
  {
    value: 3,
    label: (
      <>
        <img src="/adultBelts/3th.png" alt="3ème" /> 3ème
      </>
    ),
  },
  {
    value: 2,
    label: (
      <>
        <img src="/adultBelts/2th.png" alt="2ème" /> 2ème
      </>
    ),
  },
  {
    value: 1,
    label: (
      <>
        <img src="/adultBelts/1st.png" alt="1er" /> 1er
      </>
    ),
  },
  {
    value: 0,
    label: (
      <>
        <img src="/adultBelts/1stDan.png" alt="1er Dan" /> 1er Dan
      </>
    ),
  },
];

export const childRank = [
  {
    value: 15,
    label: (
      <>
        <img src="/childBelts/15th.png" alt="15ème" /> 15ème
      </>
    ),
  },
  {
    value: 14,
    label: (
      <>
        <img src="/childBelts/14th.png" alt="14ème" /> 14ème
      </>
    ),
  },
  {
    value: 13,
    label: (
      <>
        <img src="/childBelts/13th.png" alt="13ème" /> 13ème
      </>
    ),
  },
  {
    value: 12,
    label: (
      <>
        <img src="/childBelts/12th.png" alt="12ème" /> 12ème
      </>
    ),
  },
  {
    value: 11,
    label: (
      <>
        <img src="/childBelts/11th.png" alt="11ème" /> 11ème
      </>
    ),
  },
  {
    value: 10,
    label: (
      <>
        <img src="/childBelts/10th.png" alt="10ème" /> 10ème
      </>
    ),
  },
  {
    value: 9,
    label: (
      <>
        <img src="/childBelts/9th.png" alt="9ème" /> 9ème
      </>
    ),
  },
  {
    value: 8,
    label: (
      <>
        <img src="/childBelts/8th.png" alt="8ème" /> 8ème
      </>
    ),
  },
  {
    value: 7,
    label: (
      <>
        <img src="/childBelts/7th.png" alt="7ème" /> 7ème
      </>
    ),
  },
  {
    value: 6,
    label: (
      <>
        <img src="/childBelts/6th.png" alt="6ème" /> 6ème
      </>
    ),
  },
  {
    value: 5,
    label: (
      <>
        <img src="/childBelts/5th.png" alt="5ème" /> 5ème
      </>
    ),
  },
  {
    value: 4,
    label: (
      <>
        <img src="/childBelts/4th.png" alt="4ème" /> 4ème
      </>
    ),
  },
  {
    value: 3,
    label: (
      <>
        <img src="/childBelts/3th.png" alt="3ème" /> 3ème
      </>
    ),
  },
  {
    value: 2,
    label: (
      <>
        <img src="/childBelts/2th.png" alt="2ème" /> 2ème
      </>
    ),
  },
  {
    value: 1,
    label: (
      <>
        <img src="/childBelts/1st.png" alt="1er" /> 1er
      </>
    ),
  },
  {
    value: 0,
    label: (
      <>
        <img src="/childBelts/IIPoum.png" alt="II Poum" /> II Poum
      </>
    ),
  },
  {
    value: -1,
    label: (
      <>
        <img src="/childBelts/1stDan.png" alt="1er Dan" /> 1er Dan
      </>
    ),
  },
];
